import fetcher from 'api/fetcher';
import { MagritteNotificationName } from 'utils/constants/notification';

import { setIsVacancyForeignArea } from 'store/autoReducers';
import {
    setWizardSelectedVacancy,
    setWizardVacancies,
    setWizardVacanciesIsLoading,
    setWizardVacancyFilters,
    WizardVacancy,
} from 'store/models/campaignCreationWizard';
import { addMagritteNotification } from 'store/models/notification';
import { AppThunkAction } from 'store/utils';

type VacancyFiltersDto = { areas: { id: number; name: string }[]; users: { id: number; name: string }[] };

export const fetchWizardVacanciesAndFilters = (): AppThunkAction<Promise<void>> => (dispatch, getState) => {
    dispatch(setWizardVacanciesIsLoading(true));
    return Promise.all([
        fetcher.get<unknown, WizardVacancy[]>('/api/v1/vacancy/active_vacancies', { timeout: 30000 }),
        fetcher.get<unknown, VacancyFiltersDto>('/api/v1/vacancy/active_vacancies/filters', { timeout: 30000 }),
    ])
        .then(([vacancies, filtersDto]) => {
            if (vacancies) {
                const selectedVacancyId = getState().campaignCreationWizard.selectedVacancyId;
                const selectedVacancy = vacancies.find((vacancy) => vacancy.vacancyId === selectedVacancyId);
                const vacancyToSelect = selectedVacancy ?? vacancies[0];

                dispatch([
                    setWizardVacancies(vacancies),
                    setWizardSelectedVacancy(
                        vacancyToSelect
                            ? {
                                  vacancyId: vacancyToSelect.vacancyId,
                                  vacancyName: vacancyToSelect.name,
                                  foreignArea: vacancyToSelect.foreignArea,
                              }
                            : null
                    ),
                    setIsVacancyForeignArea(vacancyToSelect?.foreignArea ?? false),
                ]);
            }
            if (filtersDto) {
                dispatch(
                    setWizardVacancyFilters({
                        areas: filtersDto.areas.map(({ id, name }) => ({ value: String(id), text: name })),
                        users: filtersDto.users.map(({ id, name }) => ({ value: String(id), text: name })),
                    })
                );
            }
        })
        .catch(() => {
            dispatch(addMagritteNotification(MagritteNotificationName.SomethingWentWrong));
        })
        .finally(() => {
            dispatch(setWizardVacanciesIsLoading(false));
        });
};
